"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InternalTokenService = void 0;
var _webautoAuthCore = require("@tier4/webauto-auth-core");
var _handleResponseError = require("./handleResponseError");
class InternalTokenService {
  constructor(client) {
    this.client = client;
  }
  async request(req) {
    const res = await this.client.internalTokenServiceRequest(req);
    if (res.status >= 400) {
      (0, _handleResponseError.handleResponseError)(res);
    }
    const {
      data
    } = res;
    return {
      access_token: data.access_token ?? "",
      expires_in: data.expires_in ?? 0,
      refresh_token: data.refresh_token ?? "",
      scope: data.scope ?? "",
      token_type: data.token_type ?? ""
    };
  }
  async assert(req, ignoreResult = false) {
    const res = await this.getAssertResponses(req);
    if (res.status >= 500) {
      (0, _handleResponseError.handleResponseError)(res);
    }
    if (res.status === 400) {
      throw new _webautoAuthCore.InvalidToken("Access credentials are invalid", res);
    }
    if (res.status > 400) {
      (0, _handleResponseError.handleResponseError)(res);
    }
    const {
      data
    } = res;
    const ret = {
      result: data.result ?? false,
      scope: data.scope ?? "",
      missing_scope: data.missing_scope ?? "",
      feature_scope: data.feature_scope ?? "",
      missing_feature_scope: data.missing_feature_scope ?? "",
      client_application_scope: data.client_application_scope ?? "",
      missing_client_application_scope: data.missing_client_application_scope ?? "",
      client_application_id: data.client_application_id ?? "",
      is_active_token: data.is_active_token
    };
    if (!ignoreResult && !ret.result) {
      if (ret.is_active_token === false) {
        throw new _webautoAuthCore.InvalidToken("Access token is not active", res);
      }
      throw (0, _webautoAuthCore.assertionError)(req, ret);
    }
    return ret;
  }
  async assertAny(req) {
    const res = await this.getAssertAnyResponses(req);
    if (res.status >= 500) {
      (0, _handleResponseError.handleResponseError)(res);
    }
    if (res.status === 400) {
      throw new _webautoAuthCore.InvalidToken("Access credentials are invalid", res);
    }
    if (res.status > 400) {
      (0, _handleResponseError.handleResponseError)(res);
    }
    const {
      data
    } = res;
    const ret = {
      result: data.result ?? false,
      is_active_token: data.is_active_token
    };
    if (!ret.result) {
      if (ret.is_active_token === false) {
        throw new _webautoAuthCore.InvalidToken("Access token is not active", res);
      }
      throw (0, _webautoAuthCore.assertionAnyError)(req, ret);
    }
    return ret;
  }
  async introspect(req) {
    const res = await this.client.internalTokenServiceIntrospect(req);
    if (res.status >= 400) {
      (0, _handleResponseError.handleResponseError)(res);
    }
    const {
      data
    } = res;
    return {
      active: data.active ?? false,
      client_application_id: data.client_application_id ?? "",
      client_application_scope: data.client_application_scope ?? "",
      exp: data.exp ?? 0,
      feature_scope: data.feature_scope ?? "",
      scope: data.scope ?? "",
      sub: data.sub ?? "",
      token_type: data.token_type ?? ""
    };
  }
  async revoke(req) {
    const res = await this.client.internalTokenServiceRevoke(req);
    if (res.status >= 400) {
      (0, _handleResponseError.handleResponseError)(res);
    }
  }
  async getAssertResponses(req) {
    const splittedRequest = (0, _webautoAuthCore.splitAssertRequest)(req);
    const responses = await Promise.all(splittedRequest.map(request => this.client.internalTokenServiceAssert(request)));
    const errorResponses = responses.filter(res => res.status.toString().charAt(0) !== "2");
    if (errorResponses.length) return errorResponses[0];
    const data = (0, _webautoAuthCore.mergeAssertResponses)(responses.map(res => res.data));
    return {
      ...responses[0],
      data
    };
  }
  async getAssertAnyResponses(req) {
    const splittedRequest = (0, _webautoAuthCore.splitAssertAnyRequest)(req);
    const responses = await Promise.all(splittedRequest.map(request => this.client.internalTokenServiceAssertAny(request)));
    const errorResponses = responses.filter(res => res.status.toString().charAt(0) !== "2");
    if (errorResponses.length) return errorResponses[0];
    const data = (0, _webautoAuthCore.mergeAssertAnyResponses)(responses.map(res => res.data));
    return {
      ...responses[0],
      data
    };
  }
}
exports.InternalTokenService = InternalTokenService;
//# sourceMappingURL=InternalTokenService.js.map